import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BsInfoCircleFill } from 'react-icons/bs';
import styled from 'styled-components';

import { GLOSSARY, GlossaryKey } from 'utils/glossary';

const InfoIcon = styled(BsInfoCircleFill)`
  color: ${(props) => props.theme.color.text.quaternary};
  font-size: 15px;
  margin-left: 6px;
  vertical-align: middle;
  cursor: help;
  flex-shrink: 0;

  &:hover {
    color: ${(props) => props.theme.color.ui.orange};
  }
`;

const TooltipStyled = styled(Tooltip)`
  .tooltip-inner {
    max-width: 320px;
    text-align: left;
    font-size: 13px;
    line-height: 1.45;
  }
`;

interface TermInfoProps {
  /** Chave do glossário central (utils/glossary.ts) — forma preferida */
  term?: GlossaryKey;
  /** Texto livre — usar apenas quando a definição não couber no glossário */
  text?: string;
}

/**
 * Botão "i" com tooltip explicativo ao passar o mouse — padrão único da
 * plataforma para explicar termos técnicos (relatório, dashboard, formulários).
 * Preferir sempre a prop `term` (chave do glossário) para manter os textos
 * centralizados; `text` existe para casos pontuais.
 */
export const TermInfo = ({ term, text }: TermInfoProps) => {
  const content = term ? GLOSSARY[term] : text;
  if (!content) return null;

  return (
    <OverlayTrigger
      delay={{ show: 250, hide: 350 }}
      placement="top"
      overlay={(props) => <TooltipStyled {...props}>{content}</TooltipStyled>}
    >
      <span>
        <InfoIcon aria-label="O que significa este termo?" />
      </span>
    </OverlayTrigger>
  );
};
